import notFound from "@/router/pages/common/error/notFound";
import forbidden from "@/router/pages/common/error/forbidden";

const error = [...notFound, ...forbidden];

export default error;
